export enum AchievementDistributionFlags {
  CoreAchievements = 3,
  UnofficialAchievements = 5,
}
